'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../util/interfaces.js');
require('../util/user.constants.js');
var normalize = require('../util/normalize.js');
require('../util/date.js');
require('../util/static-content.js');
var index = require('../adapter/index.js');
var transport = require('../transport/transport.js');

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
(function(Device2) {
  Device2["DESKTOP"] = "Desktop";
  Device2["IPAD"] = "iPad";
  Device2["IPHONE"] = "iPhone";
  Device2["ANDROID"] = "Android Phone";
  Device2["WM7"] = "WM7";
  Device2["WM8"] = "WM8";
  Device2["IPOD"] = "iPod";
  Device2["ANDROID_TABLET"] = "Android Tablet";
})(exports.Device || (exports.Device = {}));
const GameDevices = Object.values(exports.Device);
function getGameCategories(gameSlug, categories) {
  const categoriesArray = Array.from(categories.values());
  return categoriesArray.filter((category) => category.games.has(gameSlug));
}
function getGameCategory(gameSlug, categories, defaultCategories, mobile) {
  const filteredCats = getGameCategories(gameSlug, categories).map((category) => category.slug).filter((cat) => !defaultCategories.includes(cat));
  return filteredCats[0] || (mobile ? defaultCategories[1] : defaultCategories[0]);
}
class Games {
  constructor() {
    this.production = false;
  }
  setup(options) {
    this.production = options.production;
  }
  fetch() {
    return __async(this, arguments, function* (mobile = true, lang = "en", country = "MT", device, defaultCategories = []) {
      const url = `${transport.transport.getCDNUrl()}/games/${lang}_${country}${mobile ? "_m" : ""}${this.production ? "" : "-staging"}.json`;
      const rawCategoriesAndGames = yield index.adapter.games.fetch(url);
      const gamesMap = new Map();
      const categories = new Map();
      const vendors = new Set();
      const recommendedGames = new Set();
      const addCategories = (catList) => {
        var _a;
        let categoryList2;
        if (this.isRecommendedGamesIncluded(catList)) {
          categoryList2 = catList.categories;
          catList.recommendedGames.forEach((game) => recommendedGames.add(game));
        } else {
          categoryList2 = catList;
        }
        for (const categoryEntry of categoryList2) {
          if (categoryEntry.slug === void 0) {
            continue;
          }
          categories.set(categoryEntry.slug, __spreadProps(__spreadValues({}, categoryEntry), {
            games: new Set((_a = categoryEntry.games) == null ? void 0 : _a.map((game) => game.slug)),
            subCategories: new Set()
          }));
          if (categoryEntry.subs) {
            addCategories(categoryEntry.subs);
          }
        }
      };
      const normalizeCategories = (catList) => {
        let categoryList2;
        if (this.isRecommendedGamesIncluded(catList)) {
          categoryList2 = catList.categories;
        } else {
          categoryList2 = catList;
        }
        for (const categoryEntry of categoryList2) {
          const currCategory = categories.get(categoryEntry.slug);
          const games2 = categoryEntry.games || [];
          const subCategories = categoryEntry.subs || [];
          for (const category of subCategories) {
            currCategory.subCategories.add(category.slug);
          }
          normalizeCategories(subCategories);
          for (const game of games2) {
            const devices = game.igcDevices || "";
            if (device && GameDevices.includes(device) && devices.indexOf(device) < 0) {
              continue;
            }
            gamesMap.set(game.slug, __spreadProps(__spreadValues({}, game), {
              category: getGameCategory(game.slug, categories, defaultCategories, mobile),
              categories: getGameCategories(game.slug, categories).map((cat) => cat.slug)
            }));
            if (game.customVendor && game.customVendor !== "") {
              vendors.add(game.customVendor);
            } else {
              vendors.add(game.vendor);
            }
          }
        }
      };
      addCategories(rawCategoriesAndGames);
      normalizeCategories(rawCategoriesAndGames);
      const categoryList = Array.from(categories.values()).sort((a, b) => a.position - b.position);
      return [
        gamesMap,
        categoryList,
        Array.from(vendors),
        Array.from(recommendedGames)
      ];
    });
  }
  getLastPlayedGames(numResults) {
    return index.adapter.games.getLastPlayedGames({ numResults });
  }
  getRecentWinners(args) {
    const params = {
      MinimumWin: args.min,
      Count: args.count,
      maximumWin: args.max,
      device: args.device,
      gameId: args.gameId
    };
    return index.adapter.games.getRecentWinners(params);
  }
  jackpots(currency) {
    const params = { currency };
    return index.adapter.games.jackpots(params);
  }
  getFavourites() {
    return __async(this, null, function* () {
      const result = yield index.adapter.games.getFavourites();
      return !result ? [] : result.map((favourite) => normalize.normalize(favourite));
    });
  }
  addFavouriteGame(gameId) {
    return __async(this, null, function* () {
      const result = yield index.adapter.games.favourite({
        gameId,
        remove: false
      });
      return !result ? [] : result.map((favourite) => normalize.normalize(favourite));
    });
  }
  removeFavouriteGame(gameId) {
    return __async(this, null, function* () {
      const result = yield index.adapter.games.favourite({
        gameId,
        remove: true
      });
      return !result ? [] : result.map((favourite) => normalize.normalize(favourite));
    });
  }
  launchUrl(params) {
    return index.adapter.games.launchUrl(params);
  }
  checkForActiveSessions() {
    return index.adapter.games.checkForActiveSessions();
  }
  deleteActiveSessions(params) {
    return index.adapter.games.deleteActiveSessions(params);
  }
  browser(params) {
    return index.adapter.games.browser(params);
  }
  getRecommendedGames(params) {
    return index.adapter.games.getRecommendedGames(params);
  }
  getGREMarketRecommendations(params) {
    return index.adapter.games.getGREMarketRecommendations(params);
  }
  getDynamicUserRecommendedCategory(params) {
    return index.adapter.games.getDynamicUserRecommendedCategory(params);
  }
  getGRESimilarGameRecommendations(params) {
    return index.adapter.games.getGRESimilarGameRecommendations(params);
  }
  isRecommendedGamesIncluded(payload) {
    return payload.categories !== void 0;
  }
}
const games = new Games();

exports.games = games;
exports.getGameCategories = getGameCategories;
exports.getGameCategory = getGameCategory;
